import type { IStyle, IStyleFunctionOrObject } from '@fluentui/react';
import type { IActionBarStyleProps, IActionBarStyles } from '@m365-admin/action-bar';

export function getActionBarStyles(
  props: IActionBarStyleProps,
): IStyleFunctionOrObject<IActionBarStyleProps, IActionBarStyles> {
  const itemMargin: IStyle = {
    marginRight: 8,
    marginBottom: 8,
  };

  const styles: Partial<IActionBarStyles> = {
    subComponentStyles: {
      primaryButton: (() => ({ root: [itemMargin] }))(),
      secondaryButton: (() => ({ root: [itemMargin] }))(),
    },
  };

  return styles;
}
